<template>
  <div style="margin: 0 30px;padding-bottom: 20px">
    <div style="height: 40px">
      <el-date-picker v-fixZoom :clearable="false" v-model="sendDate" type="daterange" unlink-panels size="small"
                      range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                      value-format="yyyy-MM-dd" style="margin-right: 10px; width: 400px">
      </el-date-picker>
      <el-button type="success" size="small" @click="getSearchData">查询</el-button>
    </div>
    <el-table size="small" :data="tableData" border highlight-current-row ref="singleTable" height="300px">
      <el-table-column
        type="index"
        label="序号"
        width="70"
        align="center">
      </el-table-column>
      <el-table-column
        prop="s_name"
        label="服务名称"
        min-width="100"
        align="center">
      </el-table-column>
      <el-table-column
        prop="room_name"
        label="房间"
        min-width="80"
        align="center">
      </el-table-column>
      <el-table-column
        prop="bed_name"
        label="床位"
        min-width="100"
        align="center">
      </el-table-column>
      <el-table-column
        prop="svs_esp_name"
        label="服务人员"
        min-width="120"
        align="center">
      </el-table-column>
      <el-table-column
        prop="svs_time"
        label="服务时间"
        width="90"
        align="center">
      </el-table-column>
      <el-table-column
        prop="svs_items"
        label="本次服务子项"
        min-width="120"
        align="center">
      </el-table-column>
      <el-table-column
        prop="svs_remarks"
        label="本次服务备注"
        min-width="120"
        align="center">
      </el-table-column>
    </el-table>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {queryeservicepersonrecordlist} from '../../../api/yanglaoyuan/eservice'

export default {
  name: 'lookAfter',
  props: {
    row: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      entityId: 0,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      pickerOptions: {
        // disabledDate (time) {
        //   return time.getTime() > Date.now()
        // },
        shortcuts: []
      },
      tableData: []
    }
  },
  created () {
    let loginResp = this.$store.state.user.LoginResp
    this.entityId = loginResp.entity_id
    this.getTimeObj()
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    let end = new Date().format('yyyy-MM-dd')
    const start = this.commonType.GetDateStr(-30)
    this.sendDate = [start.format('yyyy-MM-dd'), end]
    this.getSearchData()
  },
  methods: {
    // 时间
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + '-' + arr[1] + '-' + '01'
        obj.end = arr[0] + '-' + arr[1] + '-' + endDay
        endDate.push(obj)
      }
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions.shortcuts = arrTime
    },

    getSearchData () {
      this.getEservicePersonRecordData(this.row.elderlyName)
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getSearchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getSearchData()
    },

    // 访问接口
    // 获取护理记录
    getEservicePersonRecordData (elderlyName) {
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        eid: this.entityId,
        elderly_name: elderlyName,
        room_name: '',
        bed_name: '',
        svs_esp_name: '',
        start_time: this.sendDate[0] + ' 00:00:00',
        end_time: this.sendDate[1] + ' 23:59:59'
      }
      queryeservicepersonrecordlist(params, data).then(res => {
        this.tableData = res.data.arrdata
        this.totalCells = res.data.cnt
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/lookAfter.vue